import { ReactElement } from "react"

import CreateDeviceForm from "../../../../components/devices/ttr/createDeviceForm"
import ContinueVersionProvider from "../../../../components/devices/ttr/providers/continueDeviceVersionProvider"

const ContinueDraftDeviceVersion = (): ReactElement => (
    <ContinueVersionProvider>
        <CreateDeviceForm />
    </ContinueVersionProvider>
)

export default ContinueDraftDeviceVersion
